/**
 * 商品映射关系物料-查询详情
  GET /baseinfo/product/sku/material/detail
  接口ID：219514067
  接口地址：https://app.apifotwitter.com/link/project/4556737/apis/api-219514067
 */

import { get, post } from "../utils/fetch";
export var apiBaseinfoWhProductDetail = function apiBaseinfoWhProductDetail(query) {
  return get({
    url: '/baseinfo/wh/product/detail',
    query: query
  });
};

/**
  提交
  POST /baseinfo/wh/product/submit
  接口ID：218187374
  接口地址：https://app.apifotwitter.com/link/project/4556737/apis/api-218187374
 */
export var apiBaseinfoWhProductSave = function apiBaseinfoWhProductSave(data) {
  return post({
    url: '/baseinfo/wh/product/submit',
    data: data
  });
};